import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray } from 'helpers/utils';
import { ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function HocPlayerStats({ data, team }) {

  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  let teamTotal = findArray(data?.results?.items, { startSortOrder: [team] })?.statsItems;

  let fieldAthletes = athletes?.filter(ath => ath.functionDescription !== 'Goalkeeper')
  let goalkeepers = athletes?.filter(ath => ath.functionDescription === 'Goalkeeper')

  let statsArrayField = ['TOTAL', 'TOTAL', 'FG', 'PC', 'PTY', 'GC', 'YC', 'RC'];
  let statsArrayGoal = ['TOTAL_GK', 'TOTAL_GK', 'FG_GK', 'PC_GK', 'PTY_GK'];

  let itemsField = statsArrayField.map((item) => {
    let val = findArray(teamTotal, { code: [item] })
    return {
      code: item, value: val?.value, attempt: val?.attempt, percent: val?.percent
    }
  })

  let itemsGoal = statsArrayGoal.map((item) => {
    let val = findArray(teamTotal, { code: [item] })
    return {
      code: item, value: val?.value, attempt: val?.attempt, percent: val?.percent
    }
  })

  let extraFieldAth = {
    athlete: { code: '100000' },
    bib: 100000,
    title: <strong><Label data='HeaderTotals' /></strong>,
    statsItems:
      itemsField,
  }

  let extraGoalkeepers = {
    athlete: { code: '100001' },
    bib: 100001,
    title: <strong><Label data='HeaderTotals' /></strong>,
    statsItems:
      itemsGoal,
  }

  //Before to inser check if exist yet

  fieldAthletes = fieldAthletes?.filter(item => item.code !== 100000)
  goalkeepers = goalkeepers?.filter(item => item.code !== 100001)

  if (!fieldAthletes) fieldAthletes = []
  if (!goalkeepers) goalkeepers = []

  fieldAthletes?.push(extraFieldAth)
  goalkeepers?.push(extraGoalkeepers)

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;

  function ColumnBib({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderBib',
    expecialCase = false,
    remove = false,
    accessor = "bib"
  }) {
    return (
      {
        Header: <Label data={label} />,
        accessor: accessor,
        className: className,
        headerClassName: headerClassName,
        disableSortBy: disableSort,
        id: 'Bib',
        remove: remove,
        Cell: (props) => {
          const row = props.cell.row.original
          let isSuspended = (findArray(row?.eventUnitEntries, { eue_code: ['STATUS'] }).eue_value === 'SUSPEND')
          if (isSuspended) {
            return '(S)'
          }
          return (expecialCase && row.bib > 99999) ? '' : row.bib
        }
      }
    )
  }

  //Field Athletes collumns
  const tableColumnsField = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderShirtNo2', expecialCase: true }),
      ColumnNameH2H({ showStarter: false }),
      {
        id: 'PlayerStatsG/S',
        Header: <Label data="HeaderGS" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['TOTAL'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['TOTAL'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsEff%',
        Header: <Label data="HeaderEff" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['TOTAL'] }).percent;
          return value

        }
      },
      {
        id: 'PlayerStatsFG',
        Header: <Label data="HeaderFG" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsPC',
        Header: <Label data="HeaderPC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PC'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PC'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsPS',
        Header: <Label data="HeaderPS" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsGC',
        Header: <Label data="HeaderGC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['GC'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsYC',
        Header: <Label data="HeaderYC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['YC'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsRC',
        Header: <Label data="HeaderRC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['RC'] }).value;
          return value
        }
      },
    ], []
  )
  const tableColumnsFieldSM = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderShirtNo2', expecialCase: true }),
      ColumnNameH2H({ showStarter: false, hideNoc: true }),
      {
        id: 'PlayerStatsG/S',
        Header: <Label data="HeaderGS" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['TOTAL'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['TOTAL'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsEff%',
        Header: <Label data="HeaderEff" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['TOTAL'] }).percent;
          return value

        }
      },
      {
        id: 'PlayerStatsFG',
        Header: <Label data="HeaderFG" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FG'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsPC',
        Header: <Label data="HeaderPC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PC'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PC'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsPS',
        Header: <Label data="HeaderPS" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsGC',
        Header: <Label data="HeaderGC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['GC'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsYC',
        Header: <Label data="HeaderYC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['YC'] }).value;
          return value
        }
      },
      {
        id: 'PlayerStatsRC',
        Header: <Label data="HeaderRC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['RC'] }).value;
          return value
        }
      },
    ], []
  )

  //Goalskeepers collumns
  const tableColumnsGoal = useMemo(() =>
    [
      ColumnBib({ disableSort: true, label: 'HeaderShirtNo2', expecialCase: true }),
      ColumnNameH2H({ showStarter: false }),
      {
        id: 'PlayerStatsG/S',
        Header: <Label data="HeaderTotal" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['TOTAL_GK'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['TOTAL_GK'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsEff%',
        Header: <Label data="HeaderEff" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['TOTAL_GK'] }).percent;
          return value

        }
      },
      {
        id: 'PlayerStatsFG',
        Header: <Label data="HeaderFG" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['FG_GK'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['FG_GK'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsPC',
        Header: <Label data="HeaderPC" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PC_GK'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PC_GK'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
      {
        id: 'PlayerStatsPS',
        Header: <Label data="HeaderPS" sport={mirs_discipline} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let value = findArray(props.cell.row.original.statsItems, { code: ['PTY_GK'] }).value;
          let attempt = findArray(props.cell.row.original.statsItems, { code: ['PTY_GK'] }).attempt;
          return (
            <><PlayerStatsType1 value={value} attempt={attempt} /></>
          )
        }
      },
    ], []
  )

  let _captionField = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />
  let _captionGoal = <Label data='HeaderPlayerStatsGoalKeepers' sport={mirs_discipline} />

  const { breakPoint } = useViewport();
  let columnsField = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsFieldSM : tableColumnsField

  return (
    <>{ }

      <MirsTable
        id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_captionField}
        data={fieldAthletes}
        columns={columnsField}
        keyRow={"athlete-code"}
        initialSortBy={[]}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '5,3' : undefined}
        showNavExtendedData={(breakPoint === "sm" || breakPoint === "xs") ? true : undefined}
        colIndex={(breakPoint === "sm" || breakPoint === "xs") ? 1 : undefined}
      />
      <MirsTable
        id={`mirs-table-goalkeeper-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_captionGoal}
        data={goalkeepers}
        columns={tableColumnsGoal}
        keyRow={"athlete-code"}
        initialSortBy={[]}
      />
    </>
  );
}

export default HocPlayerStats;

function CaptionTeam({ competitorNoc, participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div>
  )
}

function PlayerStatsType1({ value, attempt }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}


